var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('Layout',{scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('div',{staticClass:"aside"},[_c('siteaside')],1)]},proxy:true},{key:"default",fn:function(){return [_c('RouterView')]},proxy:true}])}),_c('TopTop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }